import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { UDViewDayNightShadingType, UDViewDayNightTwilightType } from '../../../../../udView/udview';
import { DropdownListWithValueField } from '../../../../components/inputs/DropdownListWithValueField';
import { useAppDispatch } from '../../../../hooks/store-hooks';
import { patchFocusedWorkspaceView } from '../../../../state/store';
import { useWorkspace } from '../../hooks/use-view';
import { shadingTypes, twilightTypes } from './LayersFlyout.types';

export function DayNightShadingSettings() {
    const shading = useWorkspace((x) => x.view.map.dayNightShadingType);
    const twilights = useWorkspace((x) => x.view.map.selectedTwilightTypes);
    const dispatch = useAppDispatch();

    const setTwilightFlag = (e: CheckboxChangeEvent, type: UDViewDayNightTwilightType) => {
        if (e.value) {
            dispatch(
                patchFocusedWorkspaceView((v) => {
                    v.map.selectedTwilightTypes |= type;
                })
            );
        } else {
            dispatch(
                patchFocusedWorkspaceView((v) => {
                    v.map.selectedTwilightTypes &= ~type;
                })
            );
        }
    };

    return (
        <div className="px-3 py-2" id="layers-day-night-container" style={{ minWidth: 300 }}>
            <DropdownListWithValueField
                textField="label"
                data={shadingTypes}
                value={shading}
                onChange={(e) =>
                    dispatch(
                        patchFocusedWorkspaceView((v) => {
                            v.map.dayNightShadingType = e.value;
                        })
                    )
                }></DropdownListWithValueField>

            {shading === UDViewDayNightShadingType.twilight && (
                <div className={'pt-2'}>
                    {twilightTypes.map((type) => (
                        <Checkbox
                            key={type.value}
                            label={type.label}
                            value={(twilights & type.value) !== 0}
                            onChange={(e) => setTwilightFlag(e, type.value)}></Checkbox>
                    ))}
                </div>
            )}
        </div>
    );
}
